export default "__VITE_ASSET__BBRleHcn__"